/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'RIGHT_TO_FREEDOM_OF_ASSOCIATION_RIGHT_TO_FORM_OR_JOIN_A_TRADE_U',
              'RIGHTS_TO_FREELY_CHOOSE_WORKER_REPRESENTATIVES_OR_FACILITY_COMM',
              'RIGHTS_TO_BARGAIN_COLLECTIVELY',
              'NON_DISCRIMINATION_AND_NON_RETALIATION_OF_WORKERS_ON_BASIS_OF_T_NON',
              'NON_DISCRIMINATION_AND_NON_RETALIATION_OF_WORKERS_ON_BASIS_OF_T',
              'DEMOCRATIC_ELECTION_AND_ENGAGEMENT_OF_WORKER_REPRESENTATIVES',
              'COMMUNICATIONS_AND_CONSULTATION_PROCESS',
              'RIGHT_TO_PARTICIPATE_IN_STRIKES_INDUSTRIAL_ACTION',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_8: valueSchema,
  },
}
